import React, { useContext, useMemo, useState } from 'react';

import {
  UserInfoFilterDataType,
  UserInfoFilterSchema,
  UserInfoFilterSchemaInitialValues,
} from '../../../models/dashboard/filter-forms/user-info-filter.model';
import FormButtonArea from '../../Button/FormButtonArea';
import { FormSubmitButton } from '../../Button/FormSubmitButton';
import ResetFormSubmitButton from '../../Button/ResetFormSubmitButton';
// import { CustomDatePicker } from '../../FormCom/CustomDatePicker';
import {
  CustomStackedPlainRadio,
  CustomStackedPlainRadioFieldGroup,
} from '../../FormCom/CustomStackedPlainRadioField';
import FieldCollapseGroup from '../../FormCom/FieldCollapseGroup';
import { FormComponent } from '../../FormCom/FormComponent';
import { TableContext } from '../TableContext';

interface UserInfoFilterProps {}

const UserInfoFilterForm: React.FC<UserInfoFilterProps> = () => {
  const tableContext = useContext(TableContext);
  const [formInitialState, setFormInitialState] = useState({});

  useMemo(() => {
    setFormInitialState({
      ...UserInfoFilterSchemaInitialValues,
      ...tableContext?.tableSelectedFilter,
    });

    // eslint-disable-next-line
  }, []);

  if (Object.keys(formInitialState).length === 0) {
    return <div>'...'</div>;
  }

  const handleOnSubmit = (values: UserInfoFilterDataType) => {
    tableContext?.setTableSelectedFilter(values);
    tableContext?.handleSetTableFilterRecord({
      ...values,
      page: 0,
    });
  };

  return (
    <FormComponent
      initialValues={formInitialState}
      schema={UserInfoFilterSchema}
      onSubmit={handleOnSubmit}
    >
      <FieldCollapseGroup title='Status'>
        <CustomStackedPlainRadioFieldGroup name='status' className='large'>
          <CustomStackedPlainRadio name='status' value='Active' className='hug'>
            Active
          </CustomStackedPlainRadio>
          <CustomStackedPlainRadio
            name='status'
            value='Deleted'
            className='hug'
          >
            Deleted
          </CustomStackedPlainRadio>
        </CustomStackedPlainRadioFieldGroup>
      </FieldCollapseGroup>

      {/* <FieldCollapseGroup title='Date'>
        <CustomDatePicker
          label='Start Date'
          placeholder='select start date'
          name='startDate'
          id='startDate'
        />

        <CustomDatePicker
          label='End Date'
          placeholder='select end date'
          name='endDate'
          id='endDate'
        />
      </FieldCollapseGroup> */}

      <FormButtonArea>
        <ResetFormSubmitButton isTableReset={true}>
          Clear filters
        </ResetFormSubmitButton>
        <FormSubmitButton btnType='submit'>Apply Filter</FormSubmitButton>
      </FormButtonArea>
    </FormComponent>
  );
};

export default UserInfoFilterForm;
